import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c477110"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "log-msg-page" }
const _hoisted_2 = { class: "ws_common_operation ws_pr20 ws_pt20" }
const _hoisted_3 = { class: "ws_common_table" }

import { onMounted, ref, watch, onUnmounted } from 'vue'
import { Search, Tickets, QuestionFilled } from '@element-plus/icons-vue'
import {
  queryDeviceLogPage,
  exportDeviceLog,
  queryTerminalLogPage,
  queryTerminalLogDevice,
  downloadTerminalLog,
} from '@/api'
import { PAGE_SIZES, CODE_ENUM } from '@/common'
import { isEmpty } from 'lodash'
import moment from 'moment'
import { transformLogContent, downLoadFile, formatFormTime } from '@/utils'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import TypeSelect from '@/components/type-select'
import Selecttenant from '@/components/select-tenant'
import SelectDevice from '@/components/select-device'
import { ElMessage } from 'element-plus'
import { useMsgStore } from '@/stores/msg'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const advancedRef = ref()

const formatterSatelliteTime = (satelliteTime: any) => {
  return satelliteTime
    ? moment(satelliteTime).format('YYYY-MM-DD HH:mm:ss')
    : '-'
}

const tableData: any = ref([])
const formInline = ref({
  deviceSn: '',
  createTime: [],
})

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = (pageSize: number) => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = (pageSize: number) => {
  fetchList()
}
const tableLoading = ref(false)

const getMoTime = (keepAliveData: any) => {
  return {
    ...formatFormTime(keepAliveData.collectTime, ['startTime', 'endTime']),
  }
}

const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData() || {}

  const moTime = getMoTime(keepAliveData)
  const { data, reset } = queryData || {}
  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true
  const res: any = await queryTerminalLogPage({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
    ...moTime,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

onMounted(() => {
  fetchList()
})

const exportLoading = ref(false)
const exportLog = async () => {
  const ids = multipleSelection.value.map((_: any) => _.id)
  exportLoading.value = true

  const res: any = await downloadTerminalLog({
    ids,
  }).finally(() => {
    exportLoading.value = false
  })
  if (res?.code === CODE_ENUM.SUCCESS) {
    // downLoadFile(res)
    const a = document.createElement('a')
    a.href = res.data
    a.dispatchEvent(
      new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
    )
  } else {
    ElMessage.error(res?.msg?.msg)
  }
}

const deviceList: any = ref([])
const queryDeviceList = async () => {
  const res: any = await queryTerminalLogDevice()
  if (res?.code === CODE_ENUM.SUCCESS) {
    deviceList.value = res.data || []
  }
}
queryDeviceList()

const multipleSelection: any = ref([])
const handleSelectionChange = (val: any) => {
  multipleSelection.value = val
}

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(AdvancedQueryLayout), {
      class: "advance-container",
      ref_key: "advancedRef",
      ref: advancedRef,
      model: formInline.value,
      onFetchList: fetchList,
      border: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, {
          label: "设备SN",
          prop: "deviceSn"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: formInline.value.deviceSn,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.deviceSn) = $event)),
              class: "ws_select",
              filterable: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deviceList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.deviceSn,
                    label: item.deviceSn,
                    value: item.deviceSn
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form_item, {
          label: "时间",
          prop: "collectTime",
          class: "ws_time_range"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_date_picker, {
              modelValue: formInline.value.collectTime,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.collectTime) = $event)),
              "unlink-panels": "",
              type: "datetimerange",
              "range-separator": "-",
              "start-placeholder": "开始时间",
              "end-placeholder": "结束时间",
              editable: false
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_button, {
        onClick: exportLog,
        class: "ws_ml16",
        plain: "",
        disabled: multipleSelection.value.length === 0,
        loading: exportLoading.value
      }, {
        default: _withCtx(() => [
          _createTextVNode("导出")
        ]),
        _: 1
      }, 8, ["disabled", "loading"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: tableData.value,
        class: "ws_mt20",
        stripe: "",
        onSelectionChange: handleSelectionChange
      }, {
        empty: _withCtx(() => [
          _createVNode(_component_el_empty, { description: "暂无数据" })
        ]),
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { type: "selection" }),
          _createVNode(_component_el_table_column, {
            prop: "deviceSn",
            label: "设备SN",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(scope.row.deviceSn || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            prop: "fileName",
            label: "文件名",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "fileSize",
            label: "文件大小",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            prop: "createDate",
            label: "时间",
            width: "200"
          }, {
            default: _withCtx((scope) => [
              _createTextVNode(_toDisplayString(_unref(moment)(scope.row.createDate).format('YYYY-MM-DD HH:mm:ss')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, tableLoading.value]
      ]),
      _createVNode(_component_el_pagination, {
        class: "ws_mt50",
        "current-page": pageParams.value.curPage,
        "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((pageParams.value.curPage) = $event)),
        "page-size": pageParams.value.pageSize,
        "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((pageParams.value.pageSize) = $event)),
        "page-sizes": _unref(PAGE_SIZES),
        layout: "->, total, sizes, prev, pager, next, jumper ",
        total: total.value,
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange
      }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
    ])
  ]))
}
}

})